import { render, staticRenderFns } from "./CommonArticleItem.vue?vue&type=template&id=d6fd5cdc&"
import script from "./CommonArticleItem.vue?vue&type=script&lang=js&"
export * from "./CommonArticleItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports